import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export const useDeleteImpactTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.impact.delete.mutationOptions({
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.impact.impacts.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.impact.impactById.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.impact.impactList.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.impact.impactCount.queryKey(),
          }),
          // Cascade delete removes ratings too
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.impactRating.impactRatings.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey:
              trpc.frontend.impactRating.impactRatingsByImpactId.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey:
              trpc.frontend.impactRating.impactRatingsByRatedItemId.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey:
              trpc.frontend.impactRating.impactRatingsWithAppetites.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.impactRating.impactRatingCount.queryKey(),
          }),
        ]);
      },
    }),
  });

  return {
    deleteImpact: async (variables: { Id: string }): Promise<void> => {
      await mutation.mutateAsync({ Id: variables.Id });
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
